import React from 'react';
import { FormattedMessage } from 'react-intl';

export const InsuredAmountLabel = () => (
  <FormattedMessage defaultMessage='Insure Amt.' description='fulfillmentPlanner.insuredAmount' id='l7WiTG' />
);
